import { gql } from 'graphql-tag';

export const PriceFragment = gql`
  fragment PriceParts on Price {
    retailPrice {
      value
      currency
    }
    netPrice {
      value
      currency
    }
    discount {
      discountPercentage
    }
    tax {
      code
      displayRecommendation
      amount {
        value
        currency
      }
    }
    retailTax {
      code
      displayRecommendation
      amount {
        value
        currency
      }
    }
  }
`;
